<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2"
             ref="statisTitle">
            <span>课堂互动分析</span>
        </div>
        <div class="content" :style="contentStyleObj">
            <div class="classroom-inter-wrap">
                <template v-for="(item,index) in paramData">
                    <div class="inter-sec">
                        <div class="inter-item">
                            <div class="inter-count">
                                <img src="../../../assets/images/databoard/inter-cirle-one.png" width="100%"
                                     height="100%" class="big-img">
                                <div class="cirle-small">
                                    <img src="../../../assets/images/databoard/inter-cirle-two.png" width="100%"
                                         height="100%" class="small-img">
                                    <div class="count">
                                    <span class="num">
                                        <count-up
                                            class="infor-card-count user-created-count"
                                            :id-name="'code_'+item.displayCoding"
                                            :end-val="item.count"
                                            color="#0EFCFF"
                                            countSize="18"
                                            :countWeight="countWeight"
                                            :isConvert="isConvert">
                                        </count-up>
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <h1>{{item.displayName}}</h1>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import CountUp from '../../../components/countUp.vue';

    export default {
        name: "classroom-inter",
        components: {
            CountUp
        },
        data () {
            return {
                boxWrapStyleObj: {
                    height: ''
                },
                contentStyleObj: {
                    height: ''
                },
                countWeight: 700,
                isConvert: 1//是否转换数字
            }
        },
        props: {
            interTotalNum: Number,
            screenHeight: Number,
            titleHeight: Number,
            paramData: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            'screenHeight': 'initBoxHeight',
            'titleHeight': 'initBoxHeight',
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight () {
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }
                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
                this.boxWrapHeight = boxWrapHeight;
                this.boxWrapStyleObj.height = boxWrapHeight + 'px';
                this.contentStyleObj.height = contentHeight + 'px';
            }
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/databoard";

    .bg2 {
        background-image : url("../../../assets/images/sydataboard/title-bg.png");
    }

    .left-container {
        background-image  : url("../../../assets/images/databoard/icon-bg.png");
        background-repeat : no-repeat;
        background-size   : 100% 100%;
    }

    .circle {
        background-image  : url("../../../assets/images/databoard/num-item.png");
        background-repeat : no-repeat;
        background-size   : 100% 100%;
    }

    /*.inter-count {*/
    /*background-image  : url("../../../assets/images/databoard/inter-cirle-one.png");*/
    /*background-repeat : no-repeat;*/
    /*background-size   : 100% 100%;*/
    /*}*/

    /*.cirle-small {*/
        /*background-image  : url("../../../assets/images/databoard/inter-cirle-two.png");*/
        /*background-repeat : no-repeat;*/
        /*background-size   : 100% 100%;*/
    /*}*/
</style>
